<template>
	<div class='selected-lpo-header'>
		
		<div class='act-info wrapper'>
			<div class='act-info__address'>{{ ActAddress }}</div>
		</div>

		<div class='tabs-block'>
			<div class='wrapper'>
				<p-tabmenu :model='tabItems'/>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';

	export default {
		name: 'ActLpoHeader',

		data: () => ({
			tabItems: [
				{ label: 'Выделы', icon: 'fa fa-layer-group', to: { name: 'act-lpo-list' } },
				{ label: 'Аренда', icon: 'fa fa-vector-square', to: { name: 'lease' } },
				{ label: 'Абрис', icon: 'fa fa-map', to: { name: 'geometry' } },
				{ label: 'Материалы фотофиксации и треки', icon: 'fa fa-camera', to: { name: 'upload-materials' } }
			]
		}),

		computed: {

			ActAddress() {
				const arr = [];

				arr.push(this.currentLpo.forestry);
				arr.push(this.currentLpo.localforestry);

				return arr.join(' / ');
			},

			...mapState('lpoData', {
				currentLpo: state => state.currentLpo
			})
		},

				

		methods: {
			normalizeDate(date) {
				return date.split('-').reverse().join('.');
			}
		}
	};
</script>

 <style scoped src='@/style/wrapper.css'></style>

<style scoped>
	.selected-lpo-header {
		box-shadow: 0 0.01rem 0.7rem #414141;
		z-index: 10;
	}

	.act-info {
		color: #6c757d;
		display: flex;
		font-size: 1.2rem;
		justify-content: space-between;
		font-weight: bold;
		padding-top: 0.8rem;
		padding-bottom: 0.8rem;
	}
</style>

<style lang='scss' scoped>
	@import '@/style/constants.scss';

	$tabs-gap: 3px;

	.tabs-block {
		background-color: #d9d9d9;
		padding: $tabs-gap 0;
	}

	.p-tabmenu::v-deep .p-tabmenu-nav {
		background-color: inherit;
		border: none;
		gap: $tabs-gap;
	}

	.p-tabmenu::v-deep .p-tabmenuitem {
		flex: 1;
	}

	.p-tabmenu::v-deep .p-menuitem-link {
		border: none !important;
		border-radius: 2px !important;
		font-weight: 400 !important;
		justify-content: center;
		margin: 0 !important;
		height: 100%;

		transition: all ease 0.2s !important;
	}

	.p-tabmenu::v-deep .p-menuitem-link:focus {
		box-shadow: none !important;
	}

	.p-tabmenu::v-deep .p-menuitem-link:hover {
		// color: #2CC185 !important;
		color: $color-green !important;
	}

	.p-tabmenu::v-deep .p-menuitem-link.router-link-active {
		background-color: $color-green !important;
		// background-color: #2CC185 !important;
		color: #fff !important;
	}
</style>